import React from 'react';
import Welcome from '../sections/Welcome';

function Home() {
  return (
    <div className="bg-gray-100 flex flex-col items-center justify-center min-h-screen">
      <Welcome />
    </div>
  );
}

export default Home;
